module.exports = __webpack_public_path__ + "img/drunk_driving_check.7c09e3ba.png";